export const BACKGROUND_MAP_IDS = [
  'none',
  'areal2024',
  'strassenbefahrung',
  'parkraumkarte_neukoelln',
] as const

export type BackgroundMapId = (typeof BACKGROUND_MAP_IDS)[number]

export const BACKGROUND_MAP_NAMES: Record<BackgroundMapId, string> = {
  none: 'Basemap (MapTiler)',
  areal2024: 'Berlin: Luftbilder 2024',
  strassenbefahrung: 'Berlin: Straßenbefahrung 2014',
  parkraumkarte_neukoelln: 'Berlin: Parkraumkarte Neukoelln',
}
